export { default as MatchingFace } from './MatchingFace'
export { default as MatchingPerson } from './MatchingPerson'
export { default as IdentifyFace } from './IdentifyFace'
export { default as IdentifyPerson } from './IdentifyPerson'


// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/index.js